/**
 * IMPORTS
 */
import {gql} from '@apollo/client';


/**
 * TYPES
 */
import {ISubscription} from 'src/services/graphis/index.d';


/**
 * EXPORTS
 */

/**
 * I am a subscription to receive the result of a conversation analysis.
 */
export const CONVERSATION_ANALYZED: ISubscription<undefined> = {
    getTopic: () => 'conversation_analyzed',
    query: gql`
        subscription conversationAnalyzed {
            conversationAnalyzed {
                analyzedAt
                conversation
                failed
                score
            }
        }
    `,
};
